import Draggable from './Draggable';
import style from './style.scss';
/* eslint-disable react/prop-types */ // TODO: add props

export const DraggableWord = ({ id, data, disabled, children }) => {
  return (
    <Draggable
      id={id}
      data={data}
      disabled={disabled}
      className={style.draggableWord}
    >
      {children}
    </Draggable>
  );
};
